import breadcrumbsClasses from "@mui/material/Breadcrumbs/breadcrumbsClasses";
import buttonBaseClasses from "@mui/material/ButtonBase/buttonBaseClasses";
export const MuiBreadcrumbsTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                ".PixelIcon": {
                    width: dt.size.small,
                    height: dt.size.small,
                },
                [`.${breadcrumbsClasses.li}`]: {
                    color: dt.color.palette.neutrals[40],
                },
                [`.${breadcrumbsClasses.separator}`]: {
                    color: dt.color.onSurface.variant,
                },
                [`.${buttonBaseClasses.root}`]: {
                    boxSizing: "content-box",
                    width: `calc(${dt.size.small} + ${dt.inline.xSmall})`,
                    height: dt.size.small,
                    padding: `0 ${dt.inline.xSmall}`,
                    ".PixelIcon": {
                        width: dt.size.small,
                        height: dt.size.small,
                    },
                    ".MuiTouchRipple-root": {
                        opacity: 0,
                    },
                },
            },
        },
    };
};
